import { render, staticRenderFns } from "./AddPrize.vue?vue&type=template&id=b2163972&scoped=true"
import script from "./AddPrize.vue?vue&type=script&lang=js"
export * from "./AddPrize.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2163972",
  null
  
)

export default component.exports